import { AlulaReceiver } from "@app/project/model/alula-receiver";
import { AlulaReceiverBind } from "@app/project/model/alula-receiver-bind";
import { AlulaReceiverGroup } from "@app/project/model/alula-receiver-group";
import { AlulaPanelState } from "@app/project/store/projects.state";
import { ApiResultState, LoadingState } from "@app/root-store/api-result.state";
import { createFeatureSelector, createSelector } from "@ngrx/store";

const selectState = createFeatureSelector<AlulaPanelState>("alula");

export const getAlulaUser = createSelector(selectState, (state: AlulaPanelState) => (state || { user: null }).user);
export const getAlulaDevice = createSelector(selectState, (state: AlulaPanelState) => (state || { device: null }).device);
export const getActiveAlarmReportingDevices = createSelector(
    selectState,
    (state: AlulaPanelState) => (state || { activeAlarmReportingDevices: null }).activeAlarmReportingDevices
);
export const getActiveReceiverGroupDevices = createSelector(
    selectState,
    (state: AlulaPanelState) => (state || { activeReceiverGroupDevices: null }).activeReceiverGroupDevices
);
export const getAlulaDeviceEvents = createSelector(selectState, (state: AlulaPanelState) =>
    state?.events ? Object.values(state.events) : undefined
);

export const isLoadingSecurityMonitoring = createSelector(
    selectState,
    (state: AlulaPanelState) => state.monitoringServices.callState === LoadingState.loading
);

export const getAlulaReceivers = () => createSelector(selectState, (state: AlulaPanelState) => (state || { receivers: null }).receivers);
export const getAlulaReceiverById = (id: string) =>
    createSelector(getAlulaReceivers(), (receivers: ApiResultState<{ string: AlulaReceiver }>): AlulaReceiver => receivers.result[id]);
export const getAlulaReceiverGroups = () => createSelector(selectState, (state: AlulaPanelState) => (state || { groups: null }).groups);
export const getAlulaReceiverGroupById = (id: string) =>
    createSelector(
        getAlulaReceiverGroups(),
        (groups: ApiResultState<AlulaReceiverGroup[]>): AlulaReceiverGroup => groups?.result.find(receiverGroup => receiverGroup?.id === id)
    );
export const getAlulaReceiverBindsArray = createSelector(selectState, (state: AlulaPanelState) => {
    const bindGroups = (state || { binds: null }).binds;
    let binds: AlulaReceiverBind[] = [];
    for (const group in bindGroups?.result) {
        if (bindGroups.result[group]) {
            binds = [...binds, ...bindGroups.result[group]];
        }
    }

    return { result: binds, callState: bindGroups.callState };
});
export const getAlulaReceiverBinds = createSelector(selectState, (state: AlulaPanelState) => (state || { binds: null }).binds);
export const getAlulaReceiverBindById = (groupId: string, bindId: string) =>
    createSelector(
        getAlulaReceiverBinds,
        (binds: ApiResultState<{ string: AlulaReceiverBind[] }>): AlulaReceiverBind =>
            binds?.result?.[groupId]?.find(_bind => _bind?.id === bindId)
    );
export const getAlulaReceiversByGroupId = (groupId: string) =>
    createSelector(
        getAlulaReceiverBinds,
        getAlulaReceivers(),
        (binds: ApiResultState<{ string: AlulaReceiverBind[] }>, receivers: ApiResultState<{ string: AlulaReceiver }>): AlulaReceiver[] =>
            binds?.result?.[groupId]?.map(bind => receivers?.[bind.receiverId]) || []
    );
